import type { ObjectDirective } from 'vue'

function computeDelay(value: number | undefined): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '0ms'
  }
  const index = Math.floor(value)
  const clamped = Math.min(Math.max(index, 0), 10)
  return `${clamped * 40}ms`
}

export const rise: ObjectDirective<HTMLElement, number | undefined> = {
  mounted(el, binding) {
    el.classList.add('fb-rise')
    el.style.setProperty('--fb-rise-delay', computeDelay(binding.value))
  },
  updated(el, binding) {
    el.style.setProperty('--fb-rise-delay', computeDelay(binding.value))
  },
  unmounted(el) {
    el.classList.remove('fb-rise')
    el.style.removeProperty('--fb-rise-delay')
  },
}
